import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';

import ClientBrandingPageComponent from './ClientBrandingPage';
import { createBranding, getBranding, updateBranding, setSelfPayDependencyDialog, resetSelfPayDependencyDialog,getSelfPayDependencies } from '../../store/actions/clients.js';
import { selectSelectedClient } from '../../store/selectors/clients';
import { selectSessionUserClientId } from '../../store/selectors/session';
import { get } from '../../store/actions/brand';
import { getPricerConfigContracts } from '../../store/actions/pricers';
import { getTinyContractsByState } from "../../store/actions/contracts.js";
import { selectTinyContractsByState } from '../../store/selectors/contracts';
import { SelfPayDependencyDialog } from "./SelfPayDependencyDialog";


export const ClientBrandingPage = connect(
    () => {

        const selectBranding = (state) => state.clients.branding;
        const selectBrand = (state) => state.brand.data;
        const selectTinyContracts = selectTinyContractsByState;
        const selectClientId = createSelector(
            selectSelectedClient,
            selectSessionUserClientId,
            (selectedClientId, sessionClientId) => {
                return selectedClientId ?? sessionClientId
            }
        );

        const selectInitialValues = createSelector(
            selectBranding,
            selectTinyContracts,
            (branding, tinyContracts) => { 

                if (branding && branding.id) {
                    return {
                        id: branding.id,
                        logo: branding.logo,
                        logoPath: branding.logoPath,
                        usePricerLogo: branding.usePricerLogo,
                        signatureLabels:
                            branding.signatureLabelList && branding.signatureLabelList.length > 0
                                ? branding.signatureLabelList
                                : [''],
                        outpatientDisclaimer: branding.outpatientDisclaimer || "",
                        professionalDisclaimer: branding.professionalDisclaimer || "",
                        inpatientDisclaimer: branding.inpatientDisclaimer || "",
                        pricerBucket: branding.pricerBucket,

                        isPromptPayEnabled: branding.isPromptPayEnabled ?? false,
                        isSelfPayEnabled: branding.isSelfPayEnabled ?? false,
                        isOnlyForSelfPay: branding.isOnlyForSelfPay ?? false,
                        promptPayPercentage: branding.promptPayPercentage ?? null,
                        promptPayDays: branding.promptPayDays ?? null,

                        selfPayMode: branding.selfPayContractId ? 'contract' : 'percentage',
                        selfPayContract: branding.selfPayContractId
                            ? tinyContracts?.find(
                                (c) => c.id === branding.selfPayContractId
                              ) || null
                            : null,

                        selfPayPercentage: branding.selfPayPercentage ?? null,
                    };
                }

                return {
                    id: '',
                    logo: null,
                    logoPath: '',
                    usePricerLogo: false,
                    signatureLabels: [''],
                    outpatientDisclaimer: "",
                    professionalDisclaimer: "",
                    inpatientDisclaimer: "",
                    pricerBucket: branding ? branding.pricerBucket : '',

                    isPromptPayEnabled: false,
                    isSelfPayEnabled: false,
                    isOnlyForSelfPay: false,
                    promptPayPercentage: null,
                    promptPayDays: null,

                    selfPayMode: 'contract',
                    selfPayContract: null,
                    selfPayPercentage: null,
                };
            }
        );

        return (state, props) => ({
            brand: selectBrand(state, props),
            initialValues: selectInitialValues(state, props),
            clientId: selectClientId(state),

            getBrandingPending: state.clients.getBranding.pending,
            createBrandingPending: state.clients.createBranding.pending,
            updateBrandingPending: state.clients.updateBranding.pending,
            selfPayDependencies: state.clients.selfPayDependencies,
            selfPayDependencyPending:state.clients.getSelfPayDependencies.pending,
            selfPayDependencyDialog:state.clients.selfPayDependencyDialog,
            pricerPayerContracts: state.pricers.contracts,
            tinyContracts: selectTinyContracts(state),
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            getBranding: getBranding,
            getBrand: get,
            createBranding: createBranding,
            updateBranding: updateBranding,
            getPricerPayerContractsTiny: getPricerConfigContracts,
            getTinyContractsByState: getTinyContractsByState,
            setSelfPayDependencyDialog,
            resetSelfPayDependencyDialog,
            getSelfPayDependencies
        }, dispatch)
    })
)(injectIntl(ClientBrandingPageComponent));
